import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login.vue'
import Dashboard from '@/views/Dashboard.vue'
import WellManagement from '@/views/WellManagement.vue'
import PatrolManagement from '@/views/PatrolManagement.vue'
import TaskManagement from '@/views/TaskManagement.vue'
import DonationManagement from '@/views/DonationManagement.vue'
import ClaimManagement from '@/views/ClaimManagement.vue'
import TestProgressManagement from '@/views/TestProgressManagement.vue'
import RepairProgressManagement from '@/views/RepairProgressManagement.vue'
import WellClueManagement from '@/views/WellClueManagement.vue'
import FeedbackManagement from '@/views/FeedbackManagement.vue'
import UserManagement from '@/views/UserManagement.vue'
import SystemSettings from '@/views/SystemSettings.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    { path: '/login', component: Login, meta: { title: '登录', public: true } },
    { path: '/', redirect: '/dashboard' },
    { path: '/dashboard', component: Dashboard, meta: { title: '数据看板' } },
    { path: '/wells', component: WellManagement, meta: { title: '泉井管理' } },
    { path: '/patrols', component: PatrolManagement, meta: { title: '泉井巡护' } },
    { path: '/tasks', component: TaskManagement, meta: { title: '检测修缮' } },
    { path: '/donations', component: DonationManagement, meta: { title: '爱心捐赠管理' } },
    { path: '/claims', component: ClaimManagement, meta: { title: '守望者认领审批' } },
    { path: '/test-progress', component: TestProgressManagement, meta: { title: '检测进展' } },
    { path: '/repair-progress', component: RepairProgressManagement, meta: { title: '修缮进展' } },
    { path: '/clues', component: WellClueManagement, meta: { title: '泉井线索' } },
    { path: '/feedbacks', component: FeedbackManagement, meta: { title: '问题反馈' } },
    { path: '/users', component: UserManagement, meta: { title: '用户管理' } },
    { path: '/settings', component: SystemSettings, meta: { title: '系统设置' } }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.public) return next()
  const logged = localStorage.getItem('xjb_admin_logged')
  if (!logged) return next('/login')
  next()
})

export default router
